export const CurrentProductJoinableUser = () => {
    return (
        <div
            data-testid="site-activation"
            data-cohort="current-product-joinable-user"
        >
            Logged In Confluence Free - Current Product Joinable User
        </div>
    );
};
